import { useState } from 'react';
import NavBar from './NavBar';

const Layout = ({ children, user }) => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className="flex">
      {/* 1. Only show NavBar if user exists */}
      {user && <NavBar collapsed={collapsed} setCollapsed={setCollapsed} />}
      
      <main
        className={`transition-all duration-300 w-full p-4 ${
          /* 2. Only apply margins if the user is logged in */
          user 
            ? (collapsed ? 'ml-16' : 'ml-48') 
            : 'ml-0'
        }`}
      >
        {children}
      </main>
    </div>
  );
};

export default Layout;
